import z from 'zod';
import { EmailSchema, E164PhoneSchema } from '../../validation';

export interface IContact {
  name?: string;
  title?: string;
  phone?: string;
  email?: string;
}

export const getSchema = (eligibilityInd: Boolean | undefined, phoneRequired?: boolean | undefined) => {
  const name = z.string().min(1);
  const title = z.string().min(1);
  const phone = E164PhoneSchema;
  const email = EmailSchema;

  return z.object({
    name: eligibilityInd ? name : name.optional(),
    title: eligibilityInd ? title : title.optional(),
    phone: eligibilityInd ? phone : z.string().optional(),
    // phone: eligibilityInd && phoneRequired ? phone : z.string().optional(),
    email: eligibilityInd ? email : email.optional(),
  });
};
